import { render } from "./Vipysknoy.vue?vue&type=template&id=456969bc"
import script from "./Vipysknoy.vue?vue&type=script&lang=js"
export * from "./Vipysknoy.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__